import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
import { usePurchaseNotifications } from '../hooks/usePurchaseNotifications';
export function PurchaseNotification() {
  const {
    notification,
    isVisible,
    dismiss
  } = usePurchaseNotifications();
  const [position, setPosition] = useState<'bottom-left' | 'bottom-right' | 'middle-left'>('bottom-left');
  // Rotate positions periodically
  useEffect(() => {
    if (isVisible) {
      const positions: ('bottom-left' | 'bottom-right' | 'middle-left')[] = ['bottom-left', 'bottom-right', 'middle-left'];
      const randomPos = positions[Math.floor(Math.random() * positions.length)];
      setPosition(randomPos);
    }
  }, [isVisible]);
  if (!isVisible || !notification) return null;
  const positionClasses = {
    'bottom-left': 'bottom-20 md:bottom-4 left-4',
    'bottom-right': 'bottom-20 md:bottom-4 right-4',
    'middle-left': 'top-1/2 left-4 -translate-y-1/2'
  };
  return <div className={`fixed ${positionClasses[position]} z-40 max-w-xs animate-slide-in-left transition-all duration-500`} data-id="element-179">
      <div className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-start gap-3 relative overflow-hidden backdrop-blur-sm bg-white/95" data-id="element-180">
        <button onClick={dismiss} className="absolute top-1 right-1 text-gray-300 hover:text-gray-500 p-1" data-id="element-181">
          ×
        </button>

        <div className="flex-shrink-0 mt-1" data-id="element-182">
          <CheckCircle className="h-5 w-5 text-green-500" data-id="element-183" />
        </div>

        <div data-id="element-184">
          <p className="text-sm font-bold text-gray-800" data-id="element-185">
            {notification.name} de {notification.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-186">acaba de comprar el Reset</p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-187">
            hace {notification.timeAgo}
          </p>
        </div>
      </div>
    </div>;
}